/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ClearAllAction from './ClearAllAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/DesignSystem/TasksFilters/Location/Content/Header"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Show tasks in"
 weight="medium"
 color={dtColorsNeutral500}
 paddingTop={dtSpaceXxxs}
 paddingBottom={dtSpaceXxxs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
/>
<ClearAllAction
  viewPath={`${viewPath}/ClearAllAction`}
/>
</div>
{children}
</React.Fragment>)
}